import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  DatePickerComponent,
  FormActionComponent,
  FormWrapperInputComponent,
  FormWrapperItem,
  HeaderComponent,
  HeaderListComponent,
  PageListComponent,
} from "containers/backend/common/component/Index";
import {
  capitalizeFirstLetter,
  formatValidation,
  lastRequest,
  multipleValidate,
  vietnameseStringToUnicode,
} from "helpers/functions";
import Wrapper from "containers/backend/common/component/Wrapper";
import Input from "containers/backend/common/component/Input";
import { DATE_TIME_FORMAT, PATHS } from "constants/Define";
import classNames from "classnames";
import Switch from "containers/backend/common/component/Switch";
import { cloneDeep, isEmpty, set, values } from "lodash";
import moment from "moment";
import { Button, Icon, message, Modal, InputNumber } from "antd";
import * as SupplierService from "services/supplierService";
import * as WarehouseService from "services/warehouseService";
import CalendarRender from "containers/backend/common/component/CalendarRender";
import Inventory from "models/Inventory";
import "./styles.less";
import i18n from "constants/initLng";
import { useHistory, useParams } from "react-router-dom";
import useGetGoodReceipt from "hooks/useGetGoodReceiptCode";
import useAuth from "../../../../../hooks/useAuth";
import useGetInventoryDetail from "../../../../../hooks/inventory/useGetInventoryDetail";
import { suspressNegativeNumber } from "../../../../../helpers/functions";
import { parseRatingListRequestParams } from "utils/commonUtils";
import AntSelect, {
  AntOption,
} from "containers/backend/common/component/AntSelect";
import { ERROR_TYPE_WAREHOUSEMANAGEMENT } from "../../../../../constants/Define";
import Ripple from "containers/backend/common/component/Ripple";
import InventoryMultiPlan from "../InventoryMultiPlan";
import { getArrDates } from "helpers/getArrDates";
import { LoadingComponent } from "containers/backend/common/component/Index";

const propTypes = {};

const InventoryDetail = (props) => {
  //! State
  const { t, match } = props;
  const params = useParams();
  const isCreate = isEmpty(params);
  const history = useHistory();
  const user = useAuth();

  const {
    inventory,
    loading: loadingInventory,
    setInventory,
  } = useGetInventoryDetail(params.id);
  const [isTotalQuantity, setIsTotalQuantity] = useState(false);
  const [dateRange, setDateRange] = useState([]);
  const [isVisibleDate, setIsVisibleDate] = useState(false);
  const [dateRangeCalendar, setDateRangeCalendar] = useState([]);
  const [calendarValueParsed, setCalendarValueParsed] = useState([]);
  const [valueSearch, setValueSearch] = useState("");
  const [validation, setValidation] = useState(null);
  const [isDisableAction, setIsDisableAction] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  // ----- STATE FOR SELECT WITH SEARCH API ----
  const [listSupplier, setListSupplier] = useState([]);
  const [togglePlan, setTogglePlan] = useState(true);
  const [calendarData, setCalendarData] = useState([]);
  const [isDisable, setDisable] = useState(null);
  // ---------------
  const refLoading = useRef(false);
  const [isLoadingSpinner, setIsLoadingSpinner] = useState(false);
  const [isPlanSale, setIsPlanSale] = useState(null);
  //! Effect
  // ----- EFFECT FOR SELECT WITH SEARCH API -----
  const getAllSupplierProducts = useCallback(async () => {
    const params = { pageSize: 10, pageIndex: 1 };
    const listSupplier = await SupplierService.getAllSupplierProducts(params);
    setListSupplier(listSupplier);
  }, []);
  useEffect(() => {
    if (isCreate) {
      getAllSupplierProducts().catch((error) => {});
    }
  }, [isCreate]);

  // ----------------
  useEffect(() => {
    if (!isCreate) {
      const {
        usedDateFrom,
        usedDateTo,
        whPlanSales = [],
        quantity,
      } = inventory || {};
      const usedDateFromFullValue = usedDateFrom;
      const usedDateToFullValue = usedDateTo;
      const usedDateFromFullValueShortDateExport = moment(
        usedDateFromFullValue
      ).format(DATE_TIME_FORMAT.SHORT_DATE_EXPORT);

      const currtentShortDateExport = moment().format(
        DATE_TIME_FORMAT.SHORT_DATE_EXPORT
      );

      const usedDateFromValue = moment(usedDateFrom).format(
        DATE_TIME_FORMAT.SHORT_DATE
      );
      const usedDateToValue = moment(usedDateTo).format(
        DATE_TIME_FORMAT.SHORT_DATE
      );

      const isBeforeCurrentDate = moment(currtentShortDateExport).isBefore(
        usedDateFromFullValueShortDateExport
      );

      if (whPlanSales.length > 0) {
        setIsTotalQuantity(true);
      }
      setDateRangeCalendar([
        isBeforeCurrentDate ? usedDateFromFullValue : moment().add(1, "days"),
        usedDateToFullValue,
      ]);
      setCalendarValueParsed([
        isBeforeCurrentDate ? usedDateFromFullValue : moment().add(1, "days"),
        usedDateToFullValue,
      ]);
      setDateRange([usedDateFromValue, usedDateToValue]);
    }
  }, [inventory, isCreate]);

  //! Function
  const getTitleHeader = () => {
    return isCreate
      ? capitalizeFirstLetter(
          `${t("action.create")} ${t(
            "item.warehousemanagement.title"
          )}`.toLowerCase()
        )
      : capitalizeFirstLetter(
          `${t("action.update")} ${t(
            "item.warehousemanagement.title"
          )}`.toLowerCase()
        );
  };

  const onChangeTotalQuantiy = (e) => {
    if (isEmpty(dateRange)) {
      message.error(
        i18n.t(`item.warehousemanagement.errorCode.VALIDATE_EMPTY_DATE`)
      );
      return;
    }
    if(isPlanSale === null){
      setIsTotalQuantity(e);
    }
    if (isCreate) {
      set(inventory, "quantity", undefined);
    }
  };

  const onChangeRangeDate = (data) => {
    set(inventory, "quantity", undefined);
    if (isEmpty(data.fullValue)) {
      setDateRange([]);
      setDateRangeCalendar([]);
      setCalendarValueParsed([]);
      set(inventory, "usedDateFrom", undefined);
      set(inventory, "usedDateTo", undefined);
      return;
    }
    if (isDisable === false) {
      setTogglePlan(true);
    } else {
      setTogglePlan(false);
    }
    const usedDateFrom = cloneDeep(data.fullValue[0]);
    const usedDateTo = cloneDeep(data.fullValue[1]);
    if (usedDateFrom !== inventory.usedDateFrom) {
      set(inventory, "whPlanSales", []);
    }
    set(inventory, "usedDateFrom", usedDateFrom);
    set(inventory, "usedDateTo", usedDateTo);
    onChange("RangePicker", data);
    setDateRange(data.value);
    setDateRangeCalendar(data.fullValue);
    setCalendarValueParsed(data.fullValue);
    return;
  };

  const onChange = (fieldName, value) => {
    const cloneInventory = cloneDeep(inventory);
    cloneInventory[fieldName] = value;
    setInventory({ ...cloneInventory });
    if (!isCreate) {
      setIsDisableAction(false);
    }
  };

  const onChangeInventoryField = async (e) => {
    //Take Data when selected on field Search
    const findSupplier = listSupplier.find((el) => el.id === e);
    if (findSupplier) {
      const res = await WarehouseService.getSalePlanMode(findSupplier.id);
      const isPlanSaleTemp = res && res.isPlanSale;
      setIsPlanSale(isPlanSaleTemp)
      if (isPlanSaleTemp || isPlanSaleTemp === null) {
        setTogglePlan(false);
        setIsTotalQuantity(isPlanSaleTemp);
        setDisable(true);
      }else {
        setTogglePlan(true);
        setIsTotalQuantity(isPlanSaleTemp);
        setDisable(false);
      }

      const cloneInventory = cloneDeep(inventory);
      cloneInventory["materialId"] = findSupplier.id;
      cloneInventory["materialCode"] = findSupplier.productCode;
      cloneInventory["materialName"] = findSupplier.name;
      cloneInventory["supplierId"] = findSupplier.supplierId;
      cloneInventory["supplierName"] = findSupplier.supplierName;
      setInventory({ ...cloneInventory });
      setValueSearch(e);
      return;
    }
  };

  const onChangewhPlanSales = (value, date) => {
    const cloneInventory = cloneDeep(inventory);
    const whPlanSales = cloneInventory.whPlanSales;
    const eachPlanSale = {
      planUseDate: moment(date).format(DATE_TIME_FORMAT.SHORT_DATE_EXPORT),
      planQty: value || 0,
    };

    const eachPlanFound = whPlanSales.find(
      (el) => el.planUseDate === eachPlanSale.planUseDate
    );

    if (eachPlanFound) {
      eachPlanFound.planQty = value;
    } else {
      whPlanSales.push(eachPlanSale);
    }
    if (isCreate) {
      const setTotalQuantity = cloneInventory.whPlanSales.reduce(
        (prev, curr) => {
          return Number(prev) + Number(curr.planQty);
        },
        0
      );
      cloneInventory["quantity"] = setTotalQuantity;
    }
    setInventory(cloneInventory);
    if (!isCreate) {
      setIsDisableAction(false);
    }
  };

  const validate = () => {
    let validate = {
      required: {
        materialName: formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.warehousemanagement.materialName`)
        ),
        supplierName: formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.warehousemanagement.supplierName`)
        ),
        quantity: formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.warehousemanagement.quantity`)
        ),
        usedDateFrom: formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.warehousemanagement.rangeDate`)
        ),
      },
      minLength: {
        quantity: t("validation.minPhone"),
        type: t("validation.type"),
      },
    };
    let valueValidate = {
      minLength: {
        quantity: 1,
      },
    };
    const result = multipleValidate(inventory, validate, valueValidate);
    setValidation(result);
    return Object.keys(result).length < 1;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setIsLoadingSpinner(true);
      try {
        delete inventory.RangePicker;
        const cloneInventory = cloneDeep(inventory);
        cloneInventory.whPlanSales = cloneInventory.whPlanSales.map(el => ({
          ...el,
          planQty: el?.planQty || 0,
          usedQuantity: el?.usedQuantity || 0,
        }))
        if (!isTotalQuantity) {
          cloneInventory.whPlanSales = [];
        }
        cloneInventory.usedDateFrom = moment(inventory.usedDateFrom).format(
          DATE_TIME_FORMAT.SHORT_DATE_EXPORT
        );
        cloneInventory.usedDateTo = moment(inventory.usedDateTo).format(
          DATE_TIME_FORMAT.SHORT_DATE_EXPORT
        );
        if (isCreate) {
          delete cloneInventory.goodReceiptCode;
          const res = await WarehouseService.createGoodReceiptCode(
            cloneInventory
          );
          if (res) {
            message.success(
              i18n.t("item.warehousemanagement.successCode.CREATE_SUCCESS")
            );
            // setInventory(new Inventory());
            setTimeout(() => {
              history.push(PATHS.WAREHOUSEMANAGEMENT.LIST.path);
              setIsLoadingSpinner(false);
            }, 2000);
            return;
          }
        } else {
        
          const res = await WarehouseService.updateGoodReceiptCode(
            cloneInventory
          );
          if (res) {
            message.success(
              i18n.t("item.warehousemanagement.successCode.UPDATE_SUCCESS")
            );
            // setInventory(new Inventory());
            // setTimeout(() => {
            //   history.push(PATHS.WAREHOUSEMANAGEMENT.LIST.path);
            // }, 2000);
            setTimeout(() => {
              history.push(PATHS.WAREHOUSEMANAGEMENT.LIST.path);
              setIsLoadingSpinner(false)
            }, 2000);
            return;
          }
        }
      } catch (error) {
        const messageError = error && error?.data?.errors[0]?.code;
        const errorCode = ERROR_TYPE_WAREHOUSEMANAGEMENT.find(
          (el) => el === messageError
        );
        setIsLoadingSpinner(false)
        if (errorCode) {
          return message.error(
            i18n.t(`item.warehousemanagement.errorCode.${errorCode}`)
          );
        }

        return message.error(
          i18n.t(`item.warehousemanagement.errorCode.UNDEFINED_ERROR`)
        );
      }
    }
  };

  const onClickBack = () => {
    history.push(PATHS.WAREHOUSEMANAGEMENT.LIST.path);
  };
  const onClickModal = () => {
    setIsVisibleDate(true);
  };
  // ----- FUNCTION FOR SELECT WITH SEARCH API -----
  const onSearchSuppiler = (input) => {
    const inputText = vietnameseStringToUnicode(input);
    if (inputText) {
      lastRequest(500)
        .then(async () => {
          const listSupplier = await SupplierService.searchCodeSupplierProducts(
            inputText
          );
          if (listSupplier) {
            setListSupplier(listSupplier.data);
          }
          return;
        })
        .catch(setListSupplier([]));
    }
  };

  const selectFilterSearch = async (input, option) => {
    const optionText = vietnameseStringToUnicode(
      option?.props?.children?.[0]?.toLowerCase()
    );
    const inputText = vietnameseStringToUnicode(input.toLowerCase());
    return optionText.indexOf(inputText) >= 0;
  };

  const onChangeDateRangeAddMulti = (data) => {
    const cloneInventory = cloneDeep(inventory);
    const whPlanSales = cloneInventory.whPlanSales;
    const getArrDatesFound = getArrDates(data.defaultDate, data.inputValue);
    const renderwhPlanSalesForUpdate = whPlanSales.map(
      (elWHPlanUse) => {
        const newItem = getArrDatesFound.find(
          (elGetArrDatesFound) =>
            elGetArrDatesFound.planUseDate === elWHPlanUse.planUseDate
        )

        if(newItem){
          return {...newItem, usedQuantity: elWHPlanUse.usedQuantity};
        }

        return elWHPlanUse;
      }
        
    );
    if (isCreate) {
      cloneInventory.whPlanSales = getArrDatesFound;
    } else cloneInventory.whPlanSales = renderwhPlanSalesForUpdate;
    setInventory(cloneInventory);
    if (isCreate) {
      const setTotalQuantity = cloneInventory.whPlanSales.reduce(
        (prev, curr) => {
          return Number(prev) + Number(curr.planQty);
        },
        0
      );
      cloneInventory["quantity"] = setTotalQuantity;
    }
    if (!isCreate) {
      setIsDisableAction(false);
    }
  };

  const onChangeCalendar = (dateRange) => {
    setCalendarValueParsed(dateRange);
  }

  // --------
  //! Render
  return (
    <LoadingComponent spinning={isLoadingSpinner}>
      <PageListComponent>
        <HeaderListComponent
          path={match.path}
          groupPath={"warehousemanagement"}
          titleHeader={getTitleHeader()}
        />
        <FormActionComponent
          onSubmit={onSubmit}
          isDisableAction={isCreate ? false : isDisableAction}
          onClickBack={() => onClickBack()}
          action={isCreate ? "CREATE" : "UPDATE"}
          isGetItem={false}
          onChangeActive={(e) => onChange(e.name, e.value)}
          statusActiveName={`isActive`}
        >
          <FormWrapperItem>
            <HeaderComponent
              title={t("item.warehousemanagement.heading")}
              className="col-md-12 mb-3 p-2 m-b"
              style={{ borderBottom: "1px solid rgb(230, 230, 230)" }}
            />

            {/* warehousemanagementCode */}
            {!isCreate && (
              <Fragment>
                <Wrapper className="col-md-3 m-b">
                  {`${t("item.warehousemanagement.goodReceiptCode")} :`}
                </Wrapper>
                <Wrapper className="col-md-9 m-b">
                  {inventory ? inventory.goodReceiptCode : "Invalid ReceiptCode"}
                </Wrapper>
              </Fragment>
            )}

            {/* createDate */}
            {!isCreate && (
              <Fragment>
                <Wrapper className="col-md-3 m-b">
                  {`${t("item.warehousemanagement.createDate")} :`}
                </Wrapper>
                <Wrapper className="col-md-9 m-b">
                  {inventory
                    ? moment(inventory.createdDate).format(
                        DATE_TIME_FORMAT.DATE_TIME
                      )
                    : ""}
                </Wrapper>
              </Fragment>
            )}

            {/* creator */}
            <Wrapper className="col-md-3 m-b">
              {`${t("item.warehousemanagement.creator")} :`}
            </Wrapper>
            <Wrapper className="col-md-9 m-b">
              {isCreate ? user?.user?.email : inventory.createdByName}
            </Wrapper>

            {/* Search */}
            <Wrapper className="col-md-12">
              {isCreate && (
                <FormWrapperInputComponent
                  className="search-form"
                  typeInput={true}
                  messageBelowInput={true}
                  labelTitle={capitalizeFirstLetter(
                    (
                      t(`action.search`) +
                      " " +
                      t(`item.warehousemanagement.materialCode`)
                    ).toLowerCase()
                  )}
                >
                  {/* ----- SELECT WITH SEARCH API -----*/}
                  <AntSelect
                    className="select-tourcode"
                    showSearch
                    disabled={!isCreate}
                    suffixIcon={<Icon type="search" />}
                    placeholder={capitalizeFirstLetter(
                      (
                        t("placeHolderForm.input") +
                        " " +
                        t("item.warehousemanagement.materialCode")
                      ).toLowerCase()
                    )}
                    value={valueSearch}
                    onSearch={onSearchSuppiler}
                    onBlur={() => getAllSupplierProducts()}
                    filterOption={selectFilterSearch}
                    onChange={(e) => onChangeInventoryField(e)}
                    style={{ width: "100%" }}
                  >
                    {listSupplier.map((d) => (
                      <AntOption value={d.id} key={d?.id}>
                        {d.productCode} - {d.name}
                      </AntOption>
                    ))}
                  </AntSelect>
                  {/* ------------------- */}
                </FormWrapperInputComponent>
              )}
            </Wrapper>

            {/* Input Product Name */}
            <Wrapper className="col-md-6">
              <FormWrapperInputComponent
                isRequired={true}
                isValidation={true}
                messageBelowInput={true}
                validation={validation?.materialName}
                dataValidation={inventory.materialName}
                labelTitle={t(`item.warehousemanagement.materialName`)}
              >
                <Input
                  disabled
                  type="text"
                  autoComplete="off"
                  value={inventory.materialName}
                  className="form-control"
                  onChange={(e) => onChange("materialName", e.target.value)}
                />
              </FormWrapperInputComponent>
            </Wrapper>

            {/*  */}
            <Wrapper className="col-md-6">
              <FormWrapperInputComponent
                isRequired={true}
                isValidation={true}
                messageBelowInput={true}
                validation={validation?.supplierName}
                dataValidation={inventory.supplierName}
                labelTitle={t(`item.warehousemanagement.supplierName`)}
              >
                <Input
                  disabled
                  type="text"
                  autoComplete="off"
                  className="form-control"
                  name="supplierName"
                  value={inventory.supplierName}
                  onChange={(e) => onChange("supplierName", e.target.value)}
                />
              </FormWrapperInputComponent>
            </Wrapper>

            {/*  */}
            <Wrapper className="col-md-6">
              <FormWrapperInputComponent
                isRequired={true}
                isValidation={true}
                messageBelowInput={true}
                dataValidation={inventory.usedDateFrom}
                validation={validation?.usedDateFrom}
                labelTitle={t(`item.warehousemanagement.rangeDate`)}
              >
                <DatePickerComponent
                  className={classNames("form-control applyDates w100-percent")}
                  hmsComponent={`RangePicker`}
                  style={{ padding: 0, borderWidth: 0 }}
                  format={DATE_TIME_FORMAT.SHORT_DATE}
                  name={`RangePicker`}
                  value={[inventory.usedDateFrom, inventory.usedDateTo]}
                  onChange={(e) => onChangeRangeDate(e)}
                  placeholder={[
                    t("placeHolderForm.startDate"),
                    t("placeHolderForm.endDate"),
                  ]}
                  disabled={!isCreate}
                  disabledDate={(current) =>
                    current && current < moment().add(-1, "day")
                  }
                />
              </FormWrapperInputComponent>
            </Wrapper>

            {/*  */}
            <Wrapper className="col-md-6">
              <FormWrapperInputComponent
                isRequired={!isTotalQuantity}
                isValidation={true}
                dataValidation={inventory.quantity}
                validation={validation?.quantity}
                messageBelowInput={true}
                labelTitle={t(`item.warehousemanagement.quantity`)}
              >
                <Input
                  type="number"
                  min="1"
                  autoComplete="off"
                  className="form-control"
                  name="quantity"
                  disabled={!isCreate || isTotalQuantity}
                  value={inventory.quantity}
                  onKeyDown={suspressNegativeNumber}
                  onChange={(e) => onChange("quantity", e.target.value)}
                />
              </FormWrapperInputComponent>
            </Wrapper>

            {/*  */}
            <Wrapper className="col-md-12">
              <FormWrapperInputComponent
                labelTitle={t(`item.warehousemanagement.usagePlan`)}
              >
                <Switch
                  disabled={!isCreate || togglePlan}
                  className="mx-2"
                  labelRight={true}
                  checked={isTotalQuantity}
                  onChange={(e) => onChangeTotalQuantiy(e)}
                />
              </FormWrapperInputComponent>
            </Wrapper>
            {isTotalQuantity && (
              <Wrapper className="col-md-12">
                {!isEmpty(dateRange) ? (
                  <FormWrapperInputComponent
                    labelTitle={
                      t(`item.warehousemanagement.usagePlan`) +
                      (!isEmpty(dateRange)
                        ? ` từ ${dateRange[0]} - ${dateRange[1]}`
                        : "")
                    }
                  >
                    <Ripple
                      color="white"
                      style={{ borderWidth: 2 }}
                      className="btn"
                      onClick={onClickModal}
                    >
                      <Icon type="plus" className="mr-2" />
                      {t("action.addMulti")}
                    </Ripple>
                    <Modal
                      title={t("item.warehousemanagement.addMultiQuantity")}
                      visible={isVisibleDate}
                      onOk={() => {
                        setIsSubmit(true);
                        setTimeout(() => {
                          setIsSubmit(false);
                        }, 0);
                        setIsVisibleDate(false);
                      }}
                      onCancel={() => {
                        setIsSubmit(false);
                        setIsVisibleDate(false);
                      }}
                    >
                      <InventoryMultiPlan
                        isCreate={isCreate}
                        isSubmit={isSubmit}
                        startDate={
                          isCreate
                            ? inventory.usedDateFrom
                            : moment().isBefore(inventory.usedDateFrom)
                            ? inventory.usedDateFrom
                            : moment().add(1, "day")
                        }
                        endDate={isCreate
                          ? inventory.usedDateTo
                          : moment().isBefore(inventory.usedDateTo)
                          ? inventory.usedDateTo
                          : moment().add(1, "day")}
                        onChangeDateRange={onChangeDateRangeAddMulti}
                      />
                    </Modal>
                    <CalendarRender
                      value={calendarValueParsed}
                      validRange={dateRangeCalendar}
                      whPlanSales={inventory.whPlanSales}
                      onChangeDateValue={(value, date) =>
                        onChangewhPlanSales(value, date)
                      }
                      onChangeCalendar={onChangeCalendar}
                    />
                  </FormWrapperInputComponent>
                  ) : (
                  <span>
                    {t(`item.warehousemanagement.errorCode.VALIDATE_EMPTY_DATE`)}
                  </span>
                )} 
              </Wrapper>
            )}
          </FormWrapperItem>
        </FormActionComponent>
      </PageListComponent>
    </LoadingComponent>
  );
};

InventoryDetail.propTypes = propTypes;
export default InventoryDetail;
